import { TreatmentSubType } from './treatmentSubType';

export interface TreatmentType {
    id: number;
    name: string;
    isAi: boolean;
    originalId: number;

    subTypes?: TreatmentSubType[];

    /** DLS group the type belongs to (null when ungrouped). */
    groupId?: number | null;
    groupName?: string | null;
}

export type TreatmentTypes = TreatmentType[];

export enum TreatmentTypeOriginalId {
    NightGuard = 1,
    SmileDesign = 2,
    BracketRemoval = 3,
    SurgicalGuide = 4,
    PartialDenture = 5,
    ClearAligner = 6,
    SurgicalGuideWithRestoration = 7,
    BondedRestorations = 8,
    CustomBleachingTray = 9,
    FullDentures = 10,
    AINightGuard = 11,
    HybridDentures = 13,
    AIRestorations = 14,
    SmileCorrect = 15,
    Veneers = 16,
    DentalModel = 19,
    ImplantRestoration = 20,
    ManualRetainer = 21,
    Moment = 32,
    Overdenture = 33,
    /** AKA: Smile Try-in */
    TrialSmile = 38,
    ROEGuidedSmile = 42,
    ROEFullArchRestoration = 43,
    Custom = 100,
    NotSelected = 101,
}
